import React from 'react';
// src/components/ui/Badge.tsx
// One status/label pill so pages stop re-rolling their own geometry
// (STYLEGUIDE §5). Status colour is always paired with the text you pass in.

export type BadgeTone = 'neutral' | 'navy' | 'ok' | 'warn' | 'danger' | 'info';

const toneMap: Record<BadgeTone, string> = {
  neutral: 'bg-ink-100 text-ink-700',
  navy: 'bg-navy-100 text-navy-800',
  ok: 'bg-ok-bg text-ok-fg',
  warn: 'bg-warn-bg text-warn-fg',
  danger: 'bg-danger-bg text-danger-fg',
  info: 'bg-info-bg text-info-fg',
};

interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', className = '', children }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-meta font-medium ${toneMap[tone]} ${className}`}
  >
    {children}
  </span>
);

export default Badge;
